import { render, staticRenderFns } from "./EditPanelist.vue?vue&type=template&id=01807d3e&scoped=true"
import script from "./EditPanelist.vue?vue&type=script&lang=js"
export * from "./EditPanelist.vue?vue&type=script&lang=js"
import style0 from "./EditPanelist.vue?vue&type=style&index=0&id=01807d3e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01807d3e",
  null
  
)

export default component.exports